"use client"

import { TrendingUp } from "lucide-react"
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../ui/card"
import { Badge } from "../ui/badge"

interface MetricCardProps {
  title: string;
  value: number;
  label?: string;
  percentageChange?: number;
  description?: string;
  footerText?: string;
}

export function MetricCard({
  title,
  value,
  label,
  percentageChange,
  description,
  footerText,
}: MetricCardProps) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        {percentageChange !== undefined && (
          <Badge variant="secondary" className="flex items-center gap-1">
            {percentageChange > 0 ? "+" : ""}
            {percentageChange.toFixed(1)}%
            <TrendingUp className="h-3 w-3" />
          </Badge>
        )}
      </CardHeader>
      <CardContent>
        <div className="text-3xl font-bold tracking-tight">{value.toLocaleString()}</div>
        {label && (
          <p className="text-xs text-muted-foreground mt-1">{label}</p>
        )}
      </CardContent>
      {(footerText || description) && (
        <CardFooter className="flex-col gap-1 text-sm pt-0">
          {footerText && (
            <div className="flex items-center gap-2 leading-none font-medium">
              {footerText}
              <TrendingUp className="h-4 w-4" />
            </div>
          )}
          {description && (
            <div className="text-muted-foreground leading-none">
              {description}
            </div>
          )}
        </CardFooter>
      )}
    </Card>
  );
}

